import { set } from 'lodash/fp';

import { NAVIGATION_PANEL_DISPLAY_TYPE } from '../../constants/analytics';

export const PAGE_LAYOUT_NAVIGATION_PANEL_SET_DISPLAY_TYPE = 'page_layout_navigation_panel_set_display_type';
export const PAGE_LAYOUT_NAVIGATION_PANEL_SET_SECTIONS = 'page_layout_navigation_panel_set_sections';

const initialState = {
  navigationPanel: {
    displayType: NAVIGATION_PANEL_DISPLAY_TYPE.COMPACT,
    sections: {},
  },
};

const pageLayout = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_LAYOUT_NAVIGATION_PANEL_SET_DISPLAY_TYPE: {
      let requestedDisplayType = action.payload?.displayType;

      if (requestedDisplayType) {
        return set('navigationPanel.displayType', requestedDisplayType, state);
      }

      if (state.navigationPanel.displayType === NAVIGATION_PANEL_DISPLAY_TYPE.FULL) {
        return set('navigationPanel.displayType', NAVIGATION_PANEL_DISPLAY_TYPE.COMPACT, state);
      }

      return set('navigationPanel.displayType', NAVIGATION_PANEL_DISPLAY_TYPE.FULL, state);
    }
    case PAGE_LAYOUT_NAVIGATION_PANEL_SET_SECTIONS: {
      const { sectionPath } = action.payload;
      const [mainSection, secondarySection, thirdSection] = sectionPath.split('.');

      let value;

      if (thirdSection) {
        value = { [mainSection]: { [secondarySection]: { [thirdSection]: true } } };
      } else if (secondarySection) {
        value = { [mainSection]: { [secondarySection]: true } };
      } else {
        value = { [mainSection]: true };
      }

      return {
        ...state,
        navigationPanel: {
          displayType: NAVIGATION_PANEL_DISPLAY_TYPE.FULL,
          sections: value,
        },
      };
    }

    default:
      return state;
  }
};

export default pageLayout;
